import styled from 'styled-components';

export const Mark = styled.img<{ $size: number }>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  display: block;
  flex: 0 0 auto;
`;

/* The Lumio mark as a solid glyph in currentColor. `display: block` drops the inline-SVG baseline gap
   so it sits centred against text when its container centres its items. */
export const Glyph = styled.svg<{ $size: number }>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  display: block;
  flex: 0 0 auto;
`;
